import type { ComponentChildren } from 'preact';
import { EmporiumNav } from './EmporiumNav';
import { EmporiumFootnote } from './EmporiumFootnote';

/**
 * Platform chrome shell. Thin wrapper: unified platform nav + page content + platform
 * footnote. The optional <c>current</c> prop drives the active-pill marker on the nav AND
 * the brand-line breadcrumb ("Gposingway / Emporium", "Gposingway / Articles") so each
 * surface signals what section the user is on. Defaults to "emporium" because the catalog
 * is the most common Layout consumer.
 */
export function Layout({
    children,
    current = 'emporium' as const,
}: {
    children: ComponentChildren;
    current?: 'emporium' | 'articles' | 'studio' | 'pack' | null;
}) {
    return (
        <div class="flex min-h-full flex-col">
            <EmporiumNav current={current} />
            <main class="flex-1">{children}</main>
            <EmporiumFootnote />
        </div>
    );
}
